import { createFileRoute } from "@tanstack/react-router";
import { DampSurveyPage } from "@/components/damp-survey-page";
import { DAMP_SURVEY_FAQS } from "@/content/damp-survey";
import { pageSeo } from "@/lib/seo";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { ghlPreconnectLinks } from "@/lib/ghl-preconnect";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const PATH = "/damp-survey";
const TITLE = "Damp Survey South Wales | Evidence-Led Damp & Mould Diagnosis | CRS Energy";
const DESCRIPTION =
  "Evidence-led damp and mould diagnosis across Wales and the South West. Essential survey from £99, full diagnostic from £249, fully deducted from any remedial works.";

export const Route = createFileRoute("/damp-survey")({
  head: () => {
    const seo = pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    });
    return withServiceLcpPreload(PATH, {
      ...seo,
      links: [...(seo.links ?? []), ...ghlPreconnectLinks],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: DAMP_SURVEY_FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        },
      ],
    });
  },
  component: DampSurveyPage,
});
